<div class="d-flex flex-wrap">
    <div *ngFor="let p of store.players" class="card m-2 p-2" style="min-width:300px">
        <app-player-block [player]="p" [showEquipment]="true" [showAttributes]="true"></app-player-block>
        <div class="card-body">
            <button (click)="Fire(p)">Fire</button>
            <button (click)="Boost(p)">ADD EXP</button>
            <button (click)="AddCrystals(p)">ADD CL CRYSTAL</button>
        </div>


    </div>
    <div class="card m-2 p-2" style="min-width:300px">
        <app-player-setup (created)="AddPlayer($event)"></app-player-setup>
    </div>
</div>
<hr>